"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@emotion/react");
var makeInputLabelStyles = function (_a) {
    var _b;
    var isAnswered = _a.isAnswered;
    var theme = (0, react_1.useTheme)();
    return (0, react_1.css)(__assign((_b = { zIndex: 1, pointerEvents: 'none', marginTop: '-2px', marginRight: theme.mvf.spacing.medium, fontSize: theme.mvf.fontSize.little }, _b[theme.breakpoints.up('mobileMedium')] = {
        fontSize: theme.mvf.fontSize.small,
    }, _b.marginLeft = theme.mvf.spacing.medium, _b.color = theme.mvf.palette.text.primaryTextColor, _b['&.Mui-error'] = {
        color: theme.mvf.palette.status.error,
    }, _b['&.Mui-focused:not(.Mui-error)'] = {
        color: theme.mvf.palette.component.answerSelectedColor,
    }, _b['&.MuiInputLabel-shrink'] = {
        marginTop: '9px',
        fontWeight: theme.mvf.typography.weight.thick,
    }, _b), (isAnswered && {
        color: theme.mvf.palette.component.answerSelectedColor,
    })));
};
exports.default = makeInputLabelStyles;
//# sourceMappingURL=makeInputLabelStyles.js.map